import DoughnutChart from "../../../components/Doughnut.vue";
import AdminPageDataTable from "../../../components/AdminPageDataTable.vue";
import api from "./api.js"
export default {
    components: {
        DoughnutChart, AdminPageDataTable
    },
    data: () => ({
        valid:true,
        chartData:{},loaded:false,categories:[],addDialog:false,
        apiLink: "api/web/sub-category/get-admin-sub-categories",
        apiSaveLink: "api/web/sub-category/save",
        apiDeleteLink: "api/web/sub-category/delete",
        slots: [{ title: 'item.title', header: 'title', type: 'text', col: 'title' },
        { title: 'item.items', header: 'items', type: 'table' }],
        headers: [
            { text: 'Id', value: 'id' },
            { text: 'Title', value: 'title' },
            { text: 'Category', value: 'category' },
            { text: 'Nb of products', value: 'items' },
            { text: 'Actions', value: 'actions' },
        ],
        value: [15, 20, 5, 100, 23, 44, 71, 22, 0, 0, 0],
        labels: [15, 20, 5, 100, 23, 44, 71, 22, 0, 0, 0],fields: [{
            title: '',
            category_id: 0,
        }],
    }),
    mounted() {
        this.fetchStat();
        this.fetchFields();

    },

    methods: {saveRows() {
        if (!this.$refs.form.validate()) {
            return
        }
        else {
            this.$store.state.loading = true;
            const records = [];
            this.fields.forEach(element => {
                records.push(Object.values(element))
            });
            api.batchAddRows(records).then((res) => {
                if (res.data.responseCode === 1) {
                  
                    this.fetchStat();
                    this.$store.state.loading = false;

                }
                this.fields = [{
                    title: '',
                    category_id: 0,
                }];
                this.addDialog = false;
            });
        }
    },
    addRow() {
        this.fields.push({
            title: '',
            category_id: 0,
        });
    },
    removeRow(index) {
        this.fields.splice(index, 1);

    },
        randomColor() {
            const r = () => Math.floor(256 * Math.random());

            return `rgb(${r()}, ${r()}, ${r()})`;
        },
        fetchStat() {
            this.loaded = false;
            api.getStat()
                .then((res) => {
                    if (res.data.responseCode === 1) {
                        var labels = []
                        var data = []
                        var backgroundColor = []
                        res.data.data.forEach(element => {
                            labels.push(element.title);
                            data.push(element.items.length);
                            backgroundColor.push(this.randomColor())
                        });
                        this.chartData = {
                            labels: labels,
                            datasets: [
                                {
                                    backgroundColor: backgroundColor,
                                    data: data,
                                },
                            ],
                        }
                        this.loaded = true;
                    }
                });
        },
        fetchFields() {
            api.getCat()
                .then((res) => {
                    this.slots.push({ title: 'item.category', header: 'category', type: 'select', data: res.data.data, col: 'category_id' })
                    this.categories = res.data.data;
                });
        },
        fetchEntriesDebounced() {
            clearTimeout(this._timerId);
            this._timerId = setTimeout(() => {
                this.fetch();
            }, 500);
        },
    },

};